import { config, msg } from 'api';

import { setErrorMessage } from 'apps/notifications/actions/notifications';
import errorHandler from 'lib/utils/errorHandler';

export const SET_SUPERUSER_CHECKOUT_SETTINGS = 'SET_SUPERUSER_CHECKOUT_SETTINGS';

export function setSuperuserCheckoutSettings(freeDeliveryEnabled) {
  return {
    type: SET_SUPERUSER_CHECKOUT_SETTINGS,
    freeDeliveryEnabled,
  };
}

export function getSuperuserCheckoutSettings() {
  return (dispatch, getState, { network }) =>
    network.get(`${config.apiBasePath}/settings/checkout`)
      .then(response => dispatch(setSuperuserCheckoutSettings(response.freeDeliveryEnabled)))
      .catch(errorHandler);
}

export function saveSuperuserCheckoutSettings(freeDeliveryEnabled) {
  return (dispatch, getState, { network }) =>
    network.put(`${config.apiBasePath}/settings/checkout`,
      {
        body: JSON.stringify({
          freeDeliveryEnabled,
        }),
      })
      .then(() => {
        dispatch(setSuperuserCheckoutSettings(freeDeliveryEnabled));
        return true;
      })
      .catch(() => {
        dispatch(setErrorMessage(msg.settings.flashMessage.failure));
        return false;
      });
}
